export default __webpack_public_path__ + "1339c1d7c0149fbdb6509fff7b9e8a58.svg";